import React from 'react';
import { Button, useDisclosure } from "@heroui/react"
import ContactUsModal from './components/ContactUsModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';



const ContactUs: React.FC = () => {

    const [visible, setVisible] = React.useState(false);
    const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();

    const handleOnClick = () => {
        setVisible(true)
        onOpen()
    };

    return (
        <>
            <Button size='sm' className=" bg-msi-chart-midgreen text-white rounded"
                onPress={handleOnClick}
                startContent={<FontAwesomeIcon icon={faEnvelope} className="text-sm" />}>
                Contact Us
            </Button>
            {visible && <ContactUsModal
                isOpen={isOpen} onOpenChange={onOpenChange} onClose={onClose} />
            }
        </>
    )
};

export default ContactUs;